import flagHe from "../../assets/imgs/ui/decorations/flag-he.png";
import flagEn from "../../assets/imgs/ui/decorations/flag-en.png";
import { useLang } from "../../i18n/LangContext";
import "./LangBar.scss";

const LangBar = () => {
  const { lang, setLang, t } = useLang();

  return (
    <div className="mu-langbar">
      <div className="mu-langbar__inner">
        <button
          type="button"
          className={`mu-langbar__btn${lang === "he" ? " is-active" : ""}`}
          title="עברית"
          onClick={() => setLang("he")}
        >
          <img className="mu-langbar__flag" src={flagHe} alt="" />
          {t("lang_hebrew")}
        </button>
        <button
          type="button"
          className={`mu-langbar__btn${lang === "en" ? " is-active" : ""}`}
          title="English"
          onClick={() => setLang("en")}
        >
          <img className="mu-langbar__flag" src={flagEn} alt="" />
          {t("lang_english")}
        </button>
      </div>
    </div>
  );
};

export default LangBar;
